<template>
  <div class="bar_box" ref="profile">
    <div class="divPadding" :class="isJingtang ? 'divPadding2' : ''">
      <div
        class="profile"
        v-if="
          introduction?.customerPicInfos &&
          introduction.customerPicInfos[0] &&
          introduction.customerPicInfos[0].url
        "
        @click="popupVideoWin"
      >
        <img
          v-if="
            introduction?.customerPicInfos[0].url
              .toLowerCase()
              .indexOf('jpg') != -1 ||
            introduction?.customerPicInfos[0].url
              .toLowerCase()
              .indexOf('png') != -1
          "
          :src="introduction?.customerPicInfos[0].url"
        />
        <video
          v-else
          muted="muted"
          autoplay
          loop="loop"
          controls
          :src="introduction?.customerPicInfos[0].url"
        ></video>
      </div>
      <div class="profile" v-else>
        <img v-if="customerId == 78" src="./img/78.jpg" />
        <img v-if="customerId == 67" src="./img/67.jpg" />
        <img v-if="customerId == 88" src="./img/88.jpg" />
        <img
          v-if="customerId != 67 && customerId != 78 && customerId != 88 "
          src="./img/angang.jpg"
        />
      </div>
      <div
        class="text"
        :style="{
          color:
            styleType == 'typeGreen' || darkStyle
              ? '#fff'
              : isBaoSteel
              ? '#fff'
              : '#9bc0f0',
          background: isBaoSteel ? '#05196B' : 'none',
          padding: isBaoSteel ? '10px' : 'auto',
        }"
        @click="openDetail"
      >
        <marquee
          v-if="customerId !== 83 && customerId !== 138"
          width="100%"
          height="168px"
          direction="up"
          scrollamount="2"
        >
          <span
            v-html="introduction?.remark"
            :style="{ color: customerId == 89 ? '#fff' : '' }"
          ></span>
          <!-- {{ introduction?.remark }} -->
        </marquee>
        <marquee
          v-if="customerId == 138"
          width="100%"
          height="168px"
          direction="up"
          scrollamount="2"
        >
          <span
            v-text="introduction?.remark"
            :style="{ color: customerId == 89 ? '#fff' : '' }"
          ></span>
          <!-- {{ introduction?.remark }} -->
        </marquee>
        <template v-if="customerId === 83">
          <span v-html="introduction?.remark"></span>
          <!-- {{ introduction?.remark }} -->
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import videoPopup from "./component/videoPopup.vue";
import Detail from "./component/detail.vue";
export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: "introduction_new.vue",
      computedName: "企业简介组件",
      mtitle: "企业简介",
      customerId: this.$store.state.customerId,
      introduction: { remark: "" },
      styleType: "",
      isJingtang: false,
      isBaoSteel: false,
    };
  },
  components: {
    Detail,
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
    if (this.customerId === 11) this.isJingtang = true;
    this.darkStyle = bmeConfig.darkStyle;
    this.isBaoSteel = bmeConfig.isBaoSteel ? true : false;
  },
  mounted() {
    let w = $(this.$refs.profile).outerWidth();
    let h = $(this.$refs.profile).outerHeight();
    this.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: this.matrix,
      x: this.x,
      y: this.y,
    });

    this.getAbouts();
  },
  methods: {
    async getAbouts() {
      let getAbouts = CONFIG.requestName + this.$apiOpt.getAbouts;
      let data = await this.$apiUtils.get(getAbouts, {
        customerId: this.customerId,
      });
      if (data) {
        this.introduction = data;
        if (this.customerId == 66) {
          this.introduction.ext = data.remark;
          this.introduction.remark =
            "宝山钢铁股份有限公司（简称“宝钢股份”）是全球领先的现代化钢铁联合企业，是《财富》世界500强中国宝武钢铁集团有限公司的核心企业。";
        } else {
          this.introduction.ext = data.remark;
        }
      }
    },
    showHtml(str) {
      //富文本解析
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&amp;nbsp;/g, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    },
    openDetail() {
      this.$store.commit("dialogStatus", true);
      console.log(this.introduction.remark);
      this.$popup.open(
        Detail,
        this.dialogCompontent,
        {},
        {
          detail: this.introduction.ext,
        }
      );
    },
    popupVideoWin() {
      if (
        this.introduction &&
        this.introduction.customerPicInfos &&
        this.introduction.customerPicInfos.length > 0 &&
        this.introduction.customerPicInfos[0].url
      ) {
        this.$store.commit("dialogStatus", true);
        this.$popup.open(
          videoPopup,
          this.dialogCompontent,
          {},
          {
            videoUrl: this.introduction.customerPicInfos[0].url,
          }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.bar_box {
  width: 600px;
  height: 250px;
  .divPadding {
    display: flex;
    justify-content: space-between;
    padding-top: 40px;
    .profile {
      padding: 5px;
      // width: 290px;
      // height: 170px;
      @include bg-box(290px, 170px, "profileBg.png");
      // box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
      box-sizing: border-box;
      img {
        height: 100%;
        width: 100%;
      }
      video {
        height: 100%;
        width: 100%;
      }
    }
    .text {
      height: 168px;
      width: 50%;
      padding-left: 20px;
      font-size: 18px;
      font-weight: 400;
      color: #9bc0f0;
      line-height: 25px;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .divPadding2 {
    padding-top: 30px;

    .profile {
      height: 180px;
    }
    .text {
      height: 200px;
      font-size: 16px;
      position: absolute;
      right: 5px;
      top: 40px;
    }
  }
}
</style>
